// extracted by css-extract-rspack-plugin
export default {"cls1":"ProfileDropdown-cls1_HIQ","cls2":"ProfileDropdown-cls2_Dmk ProfileDropdown-cls1_HIQ"};